module.exports = __webpack_public_path__ + "views/widget_preview.html";